import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { normalizeBomWireList } from '#/api/momMgmt/settings/bom/normalizeBomWire';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

export async function fetchBomList(listQuery) {
  const { data: raw } = await request.get('/mom/bom', {
    params: listQueryToApiParams(listQuery),
  });
  const parsed = parseVer4ListResponse(raw);
  return {
    ...parsed,
    data: normalizeBomWireList(parsed.data),
  };
}
